import assertInstanceOfAny from './assertInstanceOfAny';

/**
 * Asserts that an object is instanceof an instantiator.
 *
 * @param {object} instance - The instance to check.
 * @param {function} instantiator - The instantiator to check against.
 */
export default (instance, instantiator) => assertInstanceOfAny(instance, instantiator);
